<template>
  <div class="font-controls">
    <div class="card">
      <div>
        <span class="font-family">{{ currentFont.family }}</span>
        <span class="font-weight">{{ currentFont.weight }}</span>
      </div>
      <a class="get-font" :href="currentFont.download" target="_blank">
        <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><g stroke="#8c8c8c" stroke-width="1.867" fill="none" fill-rule="evenodd"><path d="M14.333 9.889v5.333c0 .982-.796 1.778-1.777 1.778H2.778A1.778 1.778 0 011 15.222V5.444c0-.981.796-1.777 1.778-1.777H8.11M11.667 1H17v5.333M7.4 10.6L17 1"/></g></svg>
      </a>
    </div>
    <button @click="setNewFont" class="new-font">
      <span>New Font</span>
    </button>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  export default {
    name: 'font-controls',
    computed: {
      ...mapState('font', [
        'currentFont'
      ])
    },
    methods: {
      ...mapActions('font', [
        'setNewFont'
      ]),
    }
  }
</script>

<style lang="scss" scoped>
  .font-controls {
    position: absolute;
    bottom: 5vh;
    width: 24rem;
    max-width: 80%;
  }

  .card {
    width: 100%;
    padding: 1.5rem 1.25rem 1.5rem 2rem;
    border-radius: 0.5rem;
    box-shadow: 0 0.25rem 1rem rgba(0,0,0,0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .app.dark & {
      box-shadow: none;
      background: #0E0E10;
    }
  }

  span {
    display: block;
  }

  .font-family {
    font-weight: 500;
  }

  .font-weight {
    color: #8c8c8c;
    font-size: 0.875rem;
    text-transform: capitalize;
  }

  .get-font {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.75rem;
    border-radius: 100%;
    transition: all 250ms;

    &:hover {
      background: #f8f8f8;
    }

    &:active {
      background: #f0f0f0;
      transform: scale(0.9);
    }
  }

  .new-font {
    width: 100%;
    background: #f0f0f0;
    color: rgba(0,0,0,0.6);
    border-radius: 0.5rem;
    padding: 0.75rem 0;
    margin-top: 1.5rem;
    font-size: 0.875rem;
    transition: all 250ms;

    &:hover {
      background: #f4f4f4;
    }

    &:active {
      background: #ececec;
      transform: scale(0.975);
    }

    .app.dark & {
      background: #1C1C1E;
      color: #fff;
    }
  }
</style>